import React from "react";
import { formatPriceToSevenDigits } from "../../hooks/useRealtimeAreaChart";

export function LiveMarkerLayer({
  showLivePriceLine,
  normalizedChartType,
  timeframe,
  headerSeedPrice,
  liveLevelRef,
  liveDotRef,
  livePillRef,
}) {
  return (
    <>
      {!showLivePriceLine ? (
        <div
          ref={liveLevelRef}
          className="live-level"
          data-direction="up"
        />
      ) : null}
      {normalizedChartType === "area" || timeframe === "Tick" ? (
        <div
          ref={liveDotRef}
          className="live-marker-dot"
          data-variant="line"
          data-direction="up"
        />
      ) : null}
      {!showLivePriceLine ? (
        <div
          ref={livePillRef}
          className="live-marker-pill"
          data-direction="up"
        >
          {headerSeedPrice === null
            ? "--"
            : formatPriceToSevenDigits(headerSeedPrice)}
        </div>
      ) : null}
    </>
  );
}

